<script>
  import { onMount } from "svelte";
  import { createForm } from "felte";
  import reporter from "@felte/reporter-cvapi";
  import { validator } from "@felte/validator-yup";
  import * as yup from "yup";
  import config from "./config.json";
  const point = POINT || "scua";
  const location = config[[point]];
  const env = MODE || "dev";
  let submitted;

  // Setting validation messages
  yup.setLocale({
    mixed: {
      default: "Not valid",
      required: "Must not be empty",
    },
    string: {
      default: "Must be a string",
      email: "Must be a valid email",
      min: "Must not be empty",
    },
    date: {
      default: "Must enter a date",
      required: "Must enter a date",
    },
    number: {
      min: "Must be a minimum of 1",
      positive: "Number must be positive",
      integer: "Must be a whole number",
    },
  });

  // Creating yup schema
  const schema = yup.object({
    questions: yup.object({
      type: yup.string().required(),
      duration: yup.number().integer().positive().min(1),
      date: yup.date(),
      records: yup.number().integer().positive().min(1).max(50).required(),
      comments: yup.string(),
      who: yup.string(),
      mode: yup.string(),
      answeredBy: yup.string(),
      classroom: yup.string(),
      walkins: yup.number().integer().positive().min(1),
      topic: yup.string(),
      studio: yup.string(),
      affiliation: yup.string(),
      research: yup.array(),
      scans: yup.number().integer().min(0),
      reformat: yup.number().integer().min(0),
    }),
  });

  // Creating the form
  const { setField, form, data } = createForm({
    onSubmit: async (values) => {
      // console.log(values);
      let scaffold = await buildScaffold(values);
      console.log(scaffold);
      await fetch(config.proxy[[env]], {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Proxy-URL": config.url[[env]],
          Accept: "application/json",
        },
        body: JSON.stringify(scaffold),
      })
        .then(async (response) => {
          return await response.json();
        })
        .then((response) => {
          console.log(response);
          if (response.response === 1) {
            console.log("Response OK");
            submitted = true;
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            alert(
              "There was an error with the submission. Try again, but if this continues to happen, contact bradley1@vt.edu."
            );
            console.error("There was an error with the submission: ");
          }
        })
        .catch((error) => {
          alert(
            "There was an error with the submission. Try again, but if this continues to happen, contact bradley1@vt.edu."
          );
          console.error("There was an error with the submission: ");
          console.error(error);
        });
    },
    extend: [validator, reporter],
    validateSchema: schema,
  });

  let now = new Date(),
    month,
    day,
    year;
  let dateString;

  onMount(() => {
    (month = "" + (now.getMonth() + 1)),
      (day = "" + now.getDate()),
      (year = now.getFullYear());

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    dateString = [year, month, day].join("-");
    setField("questions.date", dateString);
  });

  async function copySchema(questions, structure) {
    let tempObject = {};
    Object.keys(structure).forEach((key) => {
      switch(structure[[key]]){
        case "walkins":
          tempObject[[key]] = questions.type === "Walk-in Report" ? questions[[structure[[key]]]] : 0;
          break;
        case "location.name":
          tempObject[[key]] = location.name;
          break;
        case "date":
          let tempDate = new Date();
          let time = tempDate.getHours() + ":" + tempDate.getMinutes() + ":" + tempDate.getSeconds(); 
          tempObject[[key]] =questions[[structure[[key]]]]+' '+time;
          break;
        case "research":
          tempObject[[key]] = questions[[structure[[key]]]] ? questions[[structure[[key]]]].toString() || "" : "";
          break;
        default:
        tempObject[[key]] = questions[[structure[[key]]]] || "";
      }; 
    })
    return tempObject;
  }

  async function buildScaffold(values) {
    let tempdata = [];
    for (let i = 0; i < values.questions.records; i++) {
      tempdata.push(await copySchema(values.questions, config.schema[[env]]))
    }
    return tempdata;
  }
</script>

<main>
  <div class="heading">
    <h1>
      {location.name} Reference Form {#if env === "dev"}(dev){/if}
    </h1>
  </div>
  {#if submitted}
    <div class="success"><h2>Submission was successful!</h2></div>
  {/if}
  <form use:form>
    <fieldset name="questions">
      <div class="question-container">
        <label for="reference">Reference</label>
        <input
          type="radio"
          id="reference"
          name="type"
          value="Reference"
          checked
        />
      </div>
      <div class="question-container">
        <label for="directional">Directional</label>
        <input type="radio" id="directional" name="type" value="Directional" />
      </div>
      {#if location.topic}
        <div class="question-container">
          <label for="walkin-report">Walk-in Report</label>
          <input
            type="radio"
            id="walkin-report"
            name="type"
            value="Walk-in Report"
          />
        </div>
      {/if}
      <div class="question-container">
        <label for="other">Other (add details below)</label>
        <input type="radio" id="other" name="type" value="Other" />
      </div>
      <div class="question-container">
        <label for="duration">Duration (in minutes):</label>
        <input
          id="duration"
          name="duration"
          type="number"
          value={location.name === "Art & Architecture" ? 1 : 5}
        />
      </div>
      <div class="question-container">
        <label for="date">Date:</label>
        <input id="date" name="date" type="date" value={dateString} />
      </div>
      <div class="question-container">
        <label for="records">Number of Records Being Reported:</label>
        <input id="records" name="records" type="number" value="1" />
      </div>
      <div class="question-container">
        <label for="comments">Comments/Notes:</label>
        <textarea id="comments" name="comments" />
      </div>
      <hr />
      {#if location.who}
        <div class="question-container">
          <label for="who">Who asked the question:</label>
          <select name="who" id="who" value="">
            <option value="Undergraduate">Undergraduate</option>
            {#if location.name === "VTCSOM"}<option value="Medical Student"
                >Medical Student</option
              >{/if}
            <option value="Graduate">Graduate</option>
            <option value="Faculty">Faculty</option>
            <option value="Staff">Staff</option>
            <option value="Community Member">Community Member</option>
            <option value="Unsure">Unsure</option>
            <option value="Other">Other</option>
          </select>
        </div>
      {/if}
      {#if location.affiliation}
        <div class="question-container">
          <label for="affiliation">Affiliation of Patron:</label>
          <select name="affiliation" id="affiliation" value="">
            <option value="Carilion Clinic">Carilion Clinic</option>
            <option value="FBRI - HS&T">FBRI - HS&T</option>
            <option value="General public">General public</option>
            <option value="VetMed">VetMed</option>
            <option value="VT other">VT other</option>
            <option value="VTCSOM">VTCSOM</option>
          </select>
        </div>
      {/if}
      {#if location.mode}
        <div class="question-container">
          <label for="mode">How was the question asked:</label>
          <select name="mode" id="mode" value="">
            <option value="In-person">In-person</option>
            <option value="Email">Email/Online</option>
            <option value="Phone">Phone</option>
            {#if location.name === "Special Collections and University Archives"}<option value="Letter"
                >Letter</option
              >{/if}
          </select>
        </div>
      {/if}
      {#if location.answeredBy}
        <div class="question-container">
          <label for="answeredBy">Who answered the question:</label>
          <select name="answeredBy" id="answeredBy" value="">
            <option value="Student Assistant">Student Assistant</option>
            <option value="Library Faculty/Staff">Library Faculty/Staff</option>
          </select>
        </div>
      {/if}
      {#if location.classroom}
        <div class="question-container">
          <label for="classroom">Where did you assist this person:</label>
          <select name="classroom" id="classroom" value="">
            <option value="Newman 101S">Newman 101S</option>
            <option value="Newman 207A">Newman 207A</option>
            <option value="Torgersen 3310">Torgersen 3310</option>
            <option value="Newman 317 (T&LE Suite)"
              >Newman 317 (T&LE Suite)</option
            >
            <option value="Other"
              >Other (Put details in comments section)</option
            >
          </select>
        </div>
      {/if}
      {#if location.studio}
        <div class="question-container">
          <label for="studio">Which studio is this for:</label>
          <select name="studio" id="studio" value="">
            <option value="3D Scanning Studio">3D Scanning Studio</option>
            <option value="Fusion Studio">Fusion Studio</option>
            <option value="Media Recording Studio"
              >Media Recording Studio</option
            >
            <option value="Prototyping Studio">Prototyping Studio</option>
            <option value="Studios Technology Lending Desk"
              >Studios Technology Lending Desk</option
            >
            <option value="Virtual Environments Studio"
              >Virtual Environments Studio</option
            >
          </select>
        </div>
      {/if}
      {#if location.topic}
        <div class="question-container">
          <label for="topic">The question was about:</label>
          <select name="topic" id="topic" value="">
            <option value="3D Modeling">3D Modeling</option>
            <option value="3D Printing">3D Printing</option>
            <option value="3D Scanning">3D Scanning</option>
            <option value="Audio">Audio</option>
            <option value="CNC Milling">CNC Milling</option>
            <option value="Electronics">Electronics</option>
            <option value="Laser Cutting">Laser Cutting</option>
            <option value="Motion Capture">Motion Capture</option>
            <option value="Photography">Photography</option>
            <option value="Project Management">Project Management</option>
            <option value="Vide">Video</option>
            <option value="Virtual/Augmented Reality"
              >Virtual/Augmented Reality</option
            >
            <option value="Volumetric Capture">Volumetric Capture</option>
            <option value="Other">Other</option>
          </select>
        </div>
      {/if}
      {#if location.walkins}
        <div class="question-container">
          <label for="walkins">Number of walk-ins:</label>
          <input id="walkins" name="walkins" type="number" value="1" />
        </div>
      {/if}
      {#if location.employee}
        <div class="question-container">
          <label for="employee"
            >Did the person you helped work for the library:</label
          >
          <select name="employee" id="employee" value="">
            <option value="No">No</option>
            <option value="Yes">Yes</option>
            <option value="Unsure">Unsure</option>
          </select>
        </div>
      {/if}
      {#if location.research}
        <div class="question-container research-area">
          <label for="research">Research Areas:</label>
        <div>  
        <input type="checkbox" id="research1" name="research" value="American Civil War"/>
        <label for="research1">American Civil War</label>
        </div>
        <div>
        <input type="checkbox" id="research2" name="research" value="Genealogy"/>
        <label for="research2">Genealogy</label>
      </div>
      <div>
        <input type="checkbox" id="research3" name="research" value="History of Food and Drink"/>
        <label for="research3">History of Food and Drink</label>
      </div>
      <div>
        <input type="checkbox" id="research4" name="research" value="History of Women & the Built Environment"/>
        <label for="research4">History of Women & the Built Environment</label>
      </div>
      <div>
        <input type="checkbox" id="research5" name="research" value="Local/Regional History and the Appalachian South"/>
        <label for="research5">Local/Regional History and the Appalachian South</label>
      </div>
      <div>
        <input type="checkbox" id="research6" name="research" value="Railroad"/>
        <label for="research6">Railroad</label>
      </div>
      <div>
        <input type="checkbox" id="research7" name="research" value="History of Science and Technology"/>
        <label for="research7">History of Science and Technology</label>
      </div>
      <div>
        <input type="checkbox" id="research8" name="research" value="University History"/>
        <label for="research8">University History</label>
      </div>
      <div>
        <input type="checkbox" id="research9" name="research" value="Other"/>
        <label for="research9">Other (put info in comments field)</label>
      </div>
        </div>
      {/if}
      {#if location.scans}
        <div class="question-container">
          <label for="scans">SCANS requested/produced in conjunction with this interaction:</label>
          <input id="scans" name="scans" type="number" value="0" />
        </div>
      {/if}
      {#if location.reformat}
        <div class="question-container">
          <label for="reformat">AUDIO/VISUAL REFORMATTING requested/produced in conjunction with this interaction:</label>
          <input id="reformat" name="reformat" type="number" value="0" />
        </div>
      {/if}
    </fieldset>
    <input class="submit-button" type="submit" value="Submit" />
  </form>
</main>

<style>
  main {
    text-align: center;
    margin: 0 auto;
  }

  label {
    display: inline-block;
    margin-right: 1em;
  }

  h1 {
    text-transform: uppercase;
    font-size: 3em;
    font-weight: 100;
    margin: 0;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
  .question-container {
    padding: 1em;
    display: flex;
  }

  fieldset {
    max-width: 800px;
    background-color: white;
    border: 1px solid #e5e1e6;
    -webkit-box-shadow: 0 0 10px #e5e1e6;
    box-shadow: 0 0 10px #e5e1e6;
    font-family: gineso-condensed, sans-serif;
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 1em;
  }

  textarea {
    min-width: 315px;
    min-height: 100px;
  }

  .success {
    color: green;
  }
</style>
